import { useEffect } from 'react';
import { useAppSelector } from './useAppSelector';
import { useAppDispatch } from './useAppDispatch';
import { GiaoVienService } from '../services/giao-vien/giaoVienService';
import { setList as setListGiaoVien } from '../faetures/giao-vien/giaoVienSlice';
import * as mọnHocReducer from '../faetures/mon-hoc/monHocSlice';
import { MonHocService } from '../services/mon-hoc/monHocService';
import { PhongHocService } from '../services/phong-hoc/phongHocService';
import * as phongHocReducer from '../faetures/phong-hoc/PhongHocSlice';
import { ChuyenNganhService } from '../services/chuyen-nganh/chuyenNganhService';
import * as ChuyenNganhReducer from '../faetures/chuyen-nganh/chuyenNganhSlice';
import { dotHocService } from '../services/dot_hoc/dotHocService';
import * as dotHocReducer from '../faetures/dot-hoc/dotHocSlide';
import * as lopHocReducer from '../faetures/lopTinChi/lopTinChiSlice';
import { lopService } from '../services/lop/lopService';
import { ChuyenNganhTotNghiepService } from '../services/chuyen-nganh-tot-nghiep/chuyenNganhTotNghiepService';
import * as ChuyenNganhTNReducer from '../faetures/chuyen-nganh-tot-nghiep/chuyenNganhTotNghiepSlice';
import * as loaiNganhReducer from '../faetures/loai-nganh/loaiNganhSlice';
import { loaiNganhService } from '../services/loai-nganh/loaiNganhService';

export const useCombobox = () => {
    const dispatch = useAppDispatch();
    const loadGiangVien = async () => {
        var listGiangVien = await GiaoVienService.getAll().catch(() => []);
        dispatch(setListGiaoVien(listGiangVien));
    };
    const loadMonHoc = async () => {
        var listMonHoc = await MonHocService.getAll().catch(() => []);
        dispatch(mọnHocReducer.setMonHocList(listMonHoc));
    };
    const loadPhongHoc = async () => {
        var listPhongHoc = await PhongHocService.getAll().catch(() => []);
        dispatch(phongHocReducer.setList(listPhongHoc));
    };
    const loadChuyenNganh = async () => {
        var chuyenNganhs = await ChuyenNganhService.getChuyenNganhSauDaiHoc().catch(() => []);
        dispatch(ChuyenNganhReducer.setChuyenNganhList(chuyenNganhs));
    };
    const loadDotHoc = async () => {
        var dotHocs = await dotHocService.getAll().catch(() => []);
        dispatch(dotHocReducer.setList(dotHocs));
    };
    const loadLopHoc = async () => {
        var lopHocs = await lopService.getAll().catch(() => []);
        dispatch(lopHocReducer.setListLopCombobox(lopHocs));
    };
    const loadChuyenNganhTN = async () => {
        var chuyenNganhs = await ChuyenNganhTotNghiepService.getAll().catch(() => []);
        dispatch(ChuyenNganhTNReducer.setChuyenNganhTotNghiepList(chuyenNganhs));
    };

    const loadLoaiNganh = async () => {
        var loaiNganhs = await loaiNganhService.getAll().catch(() => []);
        dispatch(loaiNganhReducer.setList(loaiNganhs));
    };
    useEffect(() => {
        loadGiangVien();
        loadMonHoc();
        loadPhongHoc();
        loadChuyenNganh();
        loadDotHoc();
        loadLopHoc();
        loadChuyenNganhTN();
        loadLoaiNganh();
    }, []);
};
